/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyIntegrationSummaryCto } from '../../models/company-integration-summary-cto';

export interface GetSummary$Json$Params {
  companyGuid: string;
}

export function getSummary$Json(http: HttpClient, rootUrl: string, params: GetSummary$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyIntegrationSummaryCto>> {
  const rb = new RequestBuilder(rootUrl, getSummary$Json.PATH, 'get');
  if (params) {
    rb.path('companyGuid', params.companyGuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompanyIntegrationSummaryCto>;
    })
  );
}

getSummary$Json.PATH = '/integrations/companies/{companyGuid}/summary';
